import { gql } from '@apollo/client'

const COMMENTS_FIELDS_FRAGMENT = gql`
  fragment CommentFields on Comment {
    id
    comment
    commentable_id
    commentable_type
    created_at
    updated_at
    user {
      id
      name
    }
  }
`

export default COMMENTS_FIELDS_FRAGMENT